import { useState, useEffect } from 'react';
import CompanyBalanceService from './CompanyBalanceService';

const useCompanyBalance = () => {
    const [balance, setBalance] = useState(null);
    const [isLoading, setIsLoading] = useState(false);
    const [error, setError] = useState(null);

    const getCompanyBalance = async () => {
        setIsLoading(true);
        setError(null);
        try {
            const response = await CompanyBalanceService.getCompanyBalance();
            setBalance(response.data);
            return response.data;
        } catch (err) {
            const errorMessage = err.response?.data?.message || 'Failed to fetch company balance';
            setError(errorMessage);
            console.error('Error fetching company balance:', err);
            return null;
        } finally {
            setIsLoading(false);
        }
    };

    useEffect(() => {
        getCompanyBalance();
    }, []);

    return {
        balance,
        isLoading,
        error,
        getCompanyBalance
    };
};

export default useCompanyBalance; 